import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { Button } from "@/components/ui/button";

const setAnalyticsConsent = (granted) => {
  try {
    localStorage.setItem("bs_cookie_consent", granted ? "granted" : "denied");
  } catch (e) {}
  if (typeof window.gtag === "function") {
    const v = granted ? "granted" : "denied";
    window.gtag("consent", "update", {
      analytics_storage: v,
      ad_storage: v,
      ad_user_data: v,
      ad_personalization: v,
    });
  }
};

const CookieBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Show until the visitor has made an explicit analytics choice
    if (!localStorage.getItem("bs_cookie_consent")) setShow(true);
    // Allow re-opening from the footer "Cookie settings" link
    const reopen = () => setShow(true);
    window.addEventListener("open-cookie-settings", reopen);
    return () => window.removeEventListener("open-cookie-settings", reopen);
  }, []);

  const accept = () => {
    setAnalyticsConsent(true);
    setShow(false);
  };

  const decline = () => {
    setAnalyticsConsent(false);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur border-t border-slate-200 shadow-[0_-1px_8px_rgba(0,0,0,0.05)]"
      data-testid="cookie-banner"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2.5 flex items-center gap-3 flex-wrap sm:flex-nowrap">
        <Cookie className="h-4 w-4 text-blue-600 shrink-0 hidden sm:block" />
        <p className="text-xs sm:text-sm text-slate-600 flex-1 min-w-0 leading-snug">
          We use analytics and advertising cookies to improve TradeOff and measure our ads. You can decline non-essential cookies.{" "}
          <Link to="/privacy#cookies" className="text-blue-600 font-medium whitespace-nowrap">Learn more</Link>
        </p>
        <div className="flex gap-2 shrink-0 ml-auto">
          <Button size="sm" variant="outline" onClick={decline} data-testid="cookie-decline" className="border-slate-300 h-8 px-3 text-xs">Decline</Button>
          <Button size="sm" onClick={accept} data-testid="cookie-accept" className="bg-blue-600 hover:bg-blue-700 h-8 px-3 text-xs">Accept analytics</Button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
